module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/settings/profile/password-change/password-change.scss
// module id = ./web/modern/components/settings/profile/password-change/password-change.scss
// module chunks = 0